import { render, staticRenderFns } from "./GuppywidgetChatBox.vue?vue&type=template&id=2982c384&"
import script from "./GuppywidgetChatBox.vue?vue&type=script&lang=js&"
export * from "./GuppywidgetChatBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports